import React, { useState, useEffect } from "react";
import { UserDetails } from "../../helpers/AuthType/authContext";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { loginUser } from "../../store/actions";
import usePost from "../../Hooks/usePost";
import { Spinner } from "reactstrap";
import Logo from "./Logo";
import OtpInput from "./OtpInput";
import ButtonSubmit from "../Buttons/ButtonSubmit";

export default function OtpForm({ props }) {
  const { userInfo } = UserDetails();
  const dispatch = useDispatch();
  const { execute, pending, data } = usePost();
  const { execute: executeResend, pending: pendingResend } = usePost();

  const length = 6;
  const [otp, setOtp] = useState(new Array(length).fill(""));
  const email = userInfo?.email;

  const handleChange = (newOtp) => {
    setOtp(newOtp);
  };

  const handleConfirmOTP = () => {
    if (otp.every((digit) => digit !== "")) {
      const otpValue = parseInt(otp.join(""), 10);
      const Method = "POST";
      const endPoint = "auth/verifyOtp";
      const token = null;
      const raw = JSON.stringify({
        email: email,
        otp: otpValue,
      });
      execute(endPoint, raw, Method, "Successfully logged in", token);
    }
  };

  const handleResendOTP = () => {
    setOtp(new Array(length).fill(""));
    const Method = "POST";
    const endPoint = `auth/resend-otp?email=${email}`;
    const token = null;
    const raw = null;
    executeResend(endPoint, raw, Method, "OTP resent", token);
  };

  useEffect(() => {
    const handleKeyPress = (e) => {
      if (e.key === "Enter" && otp?.every((digit) => digit !== "")) {
        handleConfirmOTP();
      }
    };
    window.addEventListener("keydown", handleKeyPress);
    return () => window.removeEventListener("keydown", handleKeyPress);
  }, [otp]);

  useEffect(() => {
    if (data?.data?.status === "success") {
      dispatch(loginUser(data, props.router.navigate));
    }
  }, [data?.data?.status]);

  return (
    <div className="login-form-container">
      {/* ====+ RESPONSIVE CSS FOR MOBILE +==== */}

      <style>{`
        /* Center the login form container */
        .login-form-container {
          display: flex !important;
          flex-direction: column !important;
          align-items: center !important;
          justify-content: center !important;
          text-align: center !important;
          max-width: 480px !important;
          margin: 0 auto !important;
          padding: 32px 24px !important;
        }
        
        /* Center the header and logo */
        .login-form-header {
          display: flex !important;
          flex-direction: column !important;
          align-items: center !important;
          justify-content: center !important;
          text-align: center !important;
          width: 100% !important;
          margin-bottom: 24px !important;
        }
        
        /* Center the Logo component */
        .login-form-header > div:first-child,
        .login-form-header .logo,
        .login-form-header img {
          margin: 0 auto 16px auto !important;
          display: block !important;
        }
        
        /* Mobile: Make OTP inputs fit screen */
        @media (max-width: 768px) {
          .login-form-container {
            padding: 24px 20px !important;
            width: 100% !important;
            box-sizing: border-box !important;
          }
          
          .login-form-header {
            padding: 0 !important;
            margin-bottom: 20px !important;
          }
          
          .login-form-text {
            font-size: 1.5rem !important;
            word-break: break-word !important;
            text-align: center !important;
          }
          
          .login-form-header p {
            font-size: 0.875rem !important;
            word-break: break-all !important;
            text-align: center !important;
          }
          
          .login-form-header .text-primary {
            word-break: break-all !important;
            display: inline-block !important;
            max-width: 100% !important;
          }
          
          /* OTP Input Fields - Make them fit on mobile */
          .otp-input-container,
          [class*="otp-input"],
          .otp-input {
            display: flex !important;
            justify-content: center !important;
            gap: 8px !important;
            flex-wrap: wrap !important;
            width: 100% !important;
          }
          
          .otp-input-container input,
          [class*="otp-input"] input,
          .otp-input input {
            width: 44px !important;
            height: 52px !important;
            font-size: 1.5rem !important;
            font-weight: 700 !important;
            text-align: center !important;
            padding: 8px 4px !important;
            /* ✅ BLACK TEXT - VISIBLE ON WHITE BACKGROUND */
            color: #1f2937 !important;
            background-color: #ffffff !important;
            border: 2px solid #e5e7eb !important;
            border-radius: 10px !important;
          }
          
          /* Ensure button fits mobile screen */
          .w-100.mt-3.d-flex.justify-content-center {
            width: 100% !important;
            padding: 0 !important;
            box-sizing: border-box !important;
          }
          
          /* Make Link text wrap properly */
          .d-flex.mt-3.justify-content-start {
            flex-wrap: wrap !important;
            justify-content: center !important;
            text-align: center !important;
            padding: 0 !important;
            width: 100% !important;
          }
        }
        
        /* Very small screens (< 375px) */
        @media (max-width: 375px) {
          .otp-input-container input,
          [class*="otp-input"] input,
          .otp-input input {
            width: 40px !important;
            height: 48px !important;
            font-size: 1.25rem !important;
          }
          
          .login-form-text {
            font-size: 1.25rem !important;
          }
        }
      `}</style>

      <div className="login-form-header">
        <Logo />
        <h2 className="login-form-text mb-2">Enter code</h2>
        <p>
          we sent a code to
          <span className="mx-1 text-primary">{email}</span>
        </p>
      </div>

      {pending || pendingResend ? (
        <div style={{ display: "flex", gap: 12, justifyContent: "center" }}>
          <Spinner type="grow" size="md" color="primary" />
          <Spinner type="grow" size="md" color="primary" />
          <Spinner type="grow" size="md" color="primary" />
          <Spinner type="grow" size="md" color="primary" />
          <Spinner type="grow" size="md" color="primary" />
        </div>
      ) : (
        <>
          <div className="w-100 mt-2 mb-2">
            <OtpInput length={length} otp={otp} onChange={handleChange} />
          </div>
          <div className="w-100 mt-3 d-flex justify-content-center">
            <ButtonSubmit
              Title="Confirm"
              BackgroundColor="#f68a20"
              ColorText="#fff"
              BorderColor="#f68a20"
              borderRadius={20}
              handleOnclick={handleConfirmOTP}
              pending={false}
            />
          </div>
        </>
      )}
      <div className="d-flex mt-3 justify-content-start">
        Didn't get a code ?
        <span className="mx-1" style={{ fontWeight: "bolder" }}>
          <Link onClick={handleResendOTP}>Click to resend</Link>
        </span>
      </div>
    </div>
  );
}